// Search Sidebar Enhancement - Load all products by default

class SearchSidebarEnhanced extends PredictiveSearch {
  constructor() {
    super();
    this.isHeaderSearch = this.closest('.header__search');
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    // For header search (sidebar), load all products by default
    if (this.isHeaderSearch && !currentSearchTerm.length) {
      this.loadAllProducts();
      return;
    }

    // Original behavior for non-header searches
    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  loadAllProducts() {
    const queryKey = 'all-products';
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    // Fetch with empty query to get all products
    fetch(`${routes.predictive_search_url}?q=&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        // Save to cache
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  onChange() {
    super.onChange();

    // Clear cache when user starts typing to refresh results
    const queryKey = 'all-products';
    if (this.cachedResults[queryKey] && this.searchTerm) {
      delete this.cachedResults[queryKey];
    }
  }
}

// Initialize enhanced search for header search
if (customElements.get('predictive-search')) {
  customElements.whenDefined('predictive-search').then(() => {
    document.querySelectorAll('.header__search predictive-search').forEach((element) => {
      // Check if already initialized
      if (!element.isEnhanced) {
        element.isEnhanced = true;

        // Override the loadAllProducts capability
        const originalOnFocus = element.onFocus.bind(element);
        element.onFocus = function() {
          const currentSearchTerm = this.getQuery();

          if (!currentSearchTerm.length) {
            const queryKey = 'all-products';
            this.setLiveRegionLoadingState();

            if (this.cachedResults[queryKey]) {
              this.renderSearchResults(this.cachedResults[queryKey]);
              return;
            }

            fetch(`${routes.predictive_search_url}?q=&section_id=predictive-search`, {
              signal: this.abortController.signal,
            })
              .then((response) => {
                if (!response.ok) {
                  var error = new Error(response.status);
                  this.close();
                  throw error;
                }
                return response.text();
              })
              .then((text) => {
                const resultsMarkup = new DOMParser()
                  .parseFromString(text, 'text/html')
                  .querySelector('#shopify-section-predictive-search').innerHTML;

                this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
                  predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
                });
                this.renderSearchResults(resultsMarkup);
              })
              .catch((error) => {
                if (error?.code === 20) {
                  return;
                }
                this.close();
                throw error;
              });
            return;
          }

          // Call original onFocus for searches with terms
          originalOnFocus();
        };
      }
    });
  });
}
